exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point {\n  display: grid;\n  grid-template-columns: 8rem 8rem;\n  margin-bottom: 1rem; }\n", ""]);

// exports
